

// set header name that contains versions of data
export const headerName = 'Version';
// set keys as data names in req header
export const versionsURLs = {
};